import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpBackendService } from 'src/app/core/backend-services/http/http.backend-service';
import { GameReactionInterface } from 'src/app/core/interfaces';
import { ReactionEmoji } from 'src/app/core/constants';

@Injectable({
  providedIn: 'root',
})
export class GameReactionBackendService {
  private readonly BASE_ADDRESS = '/game/reaction';

  /**
   * @description constructor of GameReactionBackendService
   * @param {HttpBackendService} http - http backend service
   */
  constructor(private http: HttpBackendService) {}

  /**
   * @description sends a reaction to a game
   * @param {string} gameUUID
   * @param {ReactionEmoji} emoji
   * @returns {Promise<GameReactionInterface>}
   */
  public sendReaction(gameUUID: string, emoji: ReactionEmoji): Promise<GameReactionInterface> {
    return firstValueFrom(
      this.http.post<GameReactionInterface>(`${this.BASE_ADDRESS}/send`, {
        gameUUID,
        emoji
      })
    );
  }

  /**
   * @description gets reactions for a game
   * @param {string} gameUUID
   * @returns {Promise<GameReactionInterface[]>}
   */
  public getReactions(gameUUID: string): Promise<GameReactionInterface[]> {
    return firstValueFrom(
      this.http.get<GameReactionInterface[]>(`${this.BASE_ADDRESS}/${gameUUID}`)
    );
  }
}